import React from 'react';
import PropTypes from 'prop-types';

import CloseThin from './../Icons/dist/components/CloseThin';
import ArrowDownThin from './../Icons/dist/components/ArrowDownThin';
import Search4 from './../Icons/dist/components/Search4';
import ThemedInputErrorSuffix from './ThemedInputErrorSuffix';
import ThemedInputHelpSuffix from './ThemedInputHelpSuffix';

import styles from './Input.scss';

var isFixVisible = function isFixVisible(fix) {
  return fix.isVisible;
};

var suffixRules = {
  inputErrorSuffix: function inputErrorSuffix(_ref) {
    var error = _ref.error,
        disabled = _ref.disabled;
    return error && !disabled;
  },
  inputHelpSuffix: function inputHelpSuffix(_ref2) {
    var help = _ref2.help,
        disabled = _ref2.disabled;
    return help && !disabled;
  },
  magnifyingGlass: function magnifyingGlass(_ref3) {
    var _magnifyingGlass = _ref3.magnifyingGlass,
        isClearButtonVisible = _ref3.isClearButtonVisible,
        error = _ref3.error;
    return _magnifyingGlass && !isClearButtonVisible && !error;
  },
  clearButton: function clearButton(_ref4) {
    var isClearButtonVisible = _ref4.isClearButtonVisible;
    return isClearButtonVisible;
  },
  menuArrow: function menuArrow(_ref5) {
    var _menuArrow = _ref5.menuArrow,
        isClearButtonVisible = _ref5.isClearButtonVisible,
        error = _ref5.error,
        magnifyingGlass = _ref5.magnifyingGlass;
    return _menuArrow && !isClearButtonVisible && !error && !magnifyingGlass;
  },
  unitSeparator: function unitSeparator(_ref6) {
    var unit = _ref6.unit;
    return !!unit;
  },
  unit: function unit(_ref7) {
    var _unit = _ref7.unit;
    return !!_unit;
  },
  customSuffix: function customSuffix(_ref8) {
    var suffix = _ref8.suffix;
    return !!suffix;
  }
};

var getVisibleSuffixCount = function getVisibleSuffixCount(args) {
  return Object.keys(suffixRules).map(function (key) {
    return suffixRules[key];
  }).map(function (fn) {
    return fn(args);
  }).filter(function (x) {
    return x;
  }).length;
};

var InputSuffix = function InputSuffix(_ref9) {
  var theme = _ref9.theme,
      errorMessage = _ref9.errorMessage,
      error = _ref9.error,
      disabled = _ref9.disabled,
      help = _ref9.help,
      helpMessage = _ref9.helpMessage,
      onIconClicked = _ref9.onIconClicked,
      magnifyingGlass = _ref9.magnifyingGlass,
      isClearButtonVisible = _ref9.isClearButtonVisible,
      onClear = _ref9.onClear,
      menuArrow = _ref9.menuArrow,
      unit = _ref9.unit,
      suffix = _ref9.suffix,
      focused = _ref9.focused,
      tooltipPlacement = _ref9.tooltipPlacement,
      onTooltipShow = _ref9.onTooltipShow;


  var suffixes = [{
    component: function component() {
      return React.createElement(ThemedInputErrorSuffix, { theme: theme, focused: focused, errorMessage: errorMessage, tooltipPlacement: tooltipPlacement, onTooltipShow: onTooltipShow });
    },
    isVisible: suffixRules.inputErrorSuffix({ error: error, disabled: disabled })
  }, {
    component: function component() {
      return React.createElement(ThemedInputHelpSuffix, { theme: theme, help: help, helpMessage: helpMessage, tooltipPlacement: tooltipPlacement, onTooltipShow: onTooltipShow });
    },
    isVisible: suffixRules.inputHelpSuffix({ help: help, disabled: disabled })
  }, {
    component: function component() {
      return React.createElement(
        'div',
        { className: styles.magnifyingGlass, disabled: disabled, onClick: onIconClicked },
        React.createElement(Search4, { size: '18px' })
      );
    },
    isVisible: suffixRules.magnifyingGlass({ magnifyingGlass: magnifyingGlass, isClearButtonVisible: isClearButtonVisible, error: error })
  }, {
    component: function component() {
      return React.createElement(
        'div',
        { onClick: onClear, className: styles.clearButton },
        React.createElement(CloseThin, { size: '6px' })
      );
    },
    isVisible: suffixRules.clearButton({ isClearButtonVisible: isClearButtonVisible })
  }, {
    component: function component() {
      return React.createElement(
        'div',
        { className: styles.menuArrow, disabled: disabled, onClick: onIconClicked },
        React.createElement(ArrowDownThin, { size: '0.6em' })
      );
    },
    isVisible: suffixRules.menuArrow({ menuArrow: menuArrow, isClearButtonVisible: isClearButtonVisible, error: error, magnifyingGlass: magnifyingGlass })
  }, {
    component: function component() {
      return React.createElement('div', { className: styles.unitSeparator });
    },
    isVisible: suffixRules.unitSeparator({ unit: unit })
  }, {
    component: function component() {
      return React.createElement(
        'div',
        { className: styles.unit, onClick: onIconClicked },
        unit
      );
    },
    isVisible: suffixRules.unit({ unit: unit })
  }, {
    component: function component() {
      return suffix;
    },
    isVisible: suffixRules.customSuffix({ suffix: suffix })
  }].filter(isFixVisible);

  return React.createElement(
    'div',
    { className: styles.suffixes },
    suffixes.map(function (s, i) {
      return React.createElement(
        'div',
        { key: i, className: styles.suffix },
        s.component()
      );
    })
  );
};

InputSuffix.propTypes = {
  suffixes: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired
  })),
  theme: PropTypes.oneOf(['normal', 'paneltitle', 'material', 'amaterial', 'flat', 'flatdark']),
  errorMessage: PropTypes.node.isRequired,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  help: PropTypes.bool,
  helpMessage: PropTypes.node,
  onIconClicked: PropTypes.func,
  magnifyingGlass: PropTypes.bool,
  isClearButtonVisible: PropTypes.bool,
  onClear: PropTypes.func,
  menuArrow: PropTypes.bool,
  unit: PropTypes.string,
  suffix: PropTypes.node,
  focused: PropTypes.bool,
  tooltipPlacement: PropTypes.string,
  onTooltipShow: PropTypes.func
};

export default InputSuffix;
export { getVisibleSuffixCount };
//# sourceMappingURL=InputSuffix.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/InputSuffix.js